const dynamicPackage = {
  detailedPlan: "Rencana Terperinci", // translated 
  minimum: "Minimum", // translated 
  maximum: "Maksimum", // translated 
};


export default dynamicPackage;
